import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  private readonly BREAKPOINT_SM = 768;

  isDeviceSmallerThan(width: number): boolean {
    return window.innerWidth <= width;
  }

  isMobile(): boolean {
    return this.isDeviceSmallerThan(this.BREAKPOINT_SM);
  }
}
